import React, { useEffect, useState } from 'react';
import styles from './AdsTempContainer.css';
import { DumpertLogo } from './DumpertLogo';

export const quotesList = [
  { label: ''},
  { label: 'Helemaal mooi'},
  { label: 'Mand!'},
  { label: 'Man man man...'},
  { label: 'Kukelekuuu'},
  { label: 'Ha Bier'},
  { label: 'Kom op dan'},
  { label: 'Nitraatje erbij?'},
  { label: 'Kangoeroe'},
  { label: 'Helemaal zand'},
  { label: 'Hondred euro?'},
  { label: 'Plausibel'},
  { label: 'Godmiljaar'},
  { label: 'Mien breur'},
  { label: 'Wegstaan'},
  { label: 'Dit is smeerpijperij'},
  { label: 'Niemand liegt tegen mij'},
  { label: 'Deze petje is echt'},
  { label: 'Woke since 2007'},
  { label: 'Hier had uw advertentie kunn.. oh'},
  { label: 'What, no money?!'},
  { label: 'Official sponsor van de Turbo Polyp'},
  { label: 'Here we go let’s goooo!'},
  { label: 'Neeeee, beter hè!'},
  { label: 'De verkeerde kaaahnt'},
  { label: 'AFVALLUH!'},
  { label: 'Ik heb zoveel saus genomen als ik wou'},
  { label: 'Horsefighter!'},
  { label: 'Nu ook live op Twitch'},
  { label: 'Nu ook op VHS'},
  { label: 'Groetjes aan Joris'},
  { label: 'In tienvoud naar je terug'},
  { label: 'Iedereen onvoldoende'},
  { label: 'Omruilgarantie tot de deur'},
  { label: 'Angelooo'},
  { label: 'Al sinds 2007 bestuurd door een reptiel'},
  { label: 'Jotawawee mkadesh'},
  { label: 'JEROEN!'},
  { label: 'Mannen met machtsposities welkom'},
  { label: 'Lachen om complotwappies kan hier'},
  { label: 'Download de app nu g-r-a-t-i-s'},
  { label: 'Village people 360-kick, bitch'},
  { label: 'Website van het jaar 2022'},
  { label: 'Poah!'},
  { label: 'G-R-A-T-I-S'},
  { label: 'Lekker Wrap, lekker tastic'},
];

export const AdsTempContainer = () => {

  const [randomNum, setRandomNum] = useState(0);

  useEffect(() => {
    setRandomNum(Math.floor(Math.random() * (quotesList.length - 1) + 1));
  }, []);

  return(
    <>
      <div className={styles.temp_container_img}></div>
      <div className={styles.temp_container}>
        <div className={styles.temp_content}>
          {randomNum !== 0 && 
           <>
             <div className={styles.title}>
               <DumpertLogo />
             </div>
             <div className={styles.subtitle}>
               {quotesList[randomNum].label}
             </div>
           </>
          }
        </div>
      </div>
    </>
  );
};